import React, {useMemo} from 'react';

import {gt} from 'app/utils/i18n';

import {AssignableLaneWithStepType} from './assignables-lists/AssignableLanes';
import {GranularTaskAssignmentsType} from './types';

interface Props {
  lanes: AssignableLaneWithStepType[];
  assignments: GranularTaskAssignmentsType;
}

export function UseLanesHintMessage({lanes, assignments}: Props) {
  const show = useMemo(() => {
    if (lanes.length > 0) {
      // hide the message if document has lanes
      return false;
    }

    const foundAssignees: {[id: string]: boolean} = {};

    for (const a of assignments) {
      const assigneeHash = `${a.user?.id}:${a.role?.id}:${a.team?.id}`;
      if (foundAssignees[assigneeHash]) {
        // assigned to more than one step
        return true;
      }
      foundAssignees[assigneeHash] = true;
    }

    return false;
  }, [lanes, assignments]);

  return show ? (
    <div className="alert alert-secondary small">
      <h5 className="alert-heading" style={{marginBottom: 0}}>
        {gt('Is assigning to multiple steps repetitive?')}
      </h5>
      <hr className="my-2" />
      <div>
        {gt(
          'Use lanes to assign to multiple steps at once. Edit this document to add lanes.'
        )}
      </div>
    </div>
  ) : null;
}
